import { Pipe, type PipeTransform } from '@angular/core';

import { SERVICE_OFFERING } from '@core/models/app.model';
import { UME_SERVICE } from '@core/services/ume-services';

@Pipe({
  name: 'companyType',
  standalone: true,
})
export class CompanyTypePipe implements PipeTransform {
  transform(company: unknown | any, fullType: boolean): string {
    if (fullType) {
      return this.getFullType(company);
    } else {
      return this.getShortType(company);
    }
  }

  public getFullType(company: unknown | any): string {
    switch (true) {
      case company.serviceOfferings.includes(SERVICE_OFFERING.STANDARD_PLUS):
        return 'Standard +';
      case company.serviceOfferings.includes(SERVICE_OFFERING.V_PREMIUM):
        return 'Virtual premium';
      case company.serviceOfferings.includes(SERVICE_OFFERING.SUB_ACCOUNT):
        return 'Sub-account';
      case company.services.includes(UME_SERVICE.FUND_DISTRIBUTORS_OVERSIGHT):
        return 'Premium';
      default:
        return 'Standard';
    }
  }

  public getShortType(company: unknown | any): string {
    switch (true) {
      case company.serviceOfferings.includes(SERVICE_OFFERING.STANDARD_PLUS):
        return 'S+';
      case company.serviceOfferings.includes(SERVICE_OFFERING.V_PREMIUM):
        return 'VP';
      case company.serviceOfferings.includes(SERVICE_OFFERING.SUB_ACCOUNT):
        return 'SA';
      case company.services.includes(UME_SERVICE.FUND_DISTRIBUTORS_OVERSIGHT):
        return 'P';
      default:
        return 'S';
    }
  }
}
